import AuthValidation from "../../validation/AuthValidation";
import { IRequestModel, HttpMethod, ValidationResponse } from "../../IRequestModel";

export class DiscordAuthRequest implements IRequestModel {

    constructor(grantToken: string) {
        this.grant_token = grantToken;
    }

    uri: string = "server/discordauth";
    method: HttpMethod = HttpMethod.POST;

    grant_token: string;

    isValid(): ValidationResponse {
        return ValidationResponse.Success();
    }
}